import { render, staticRenderFns } from "./TipsContainer.vue?vue&type=template&id=053eeae9&scoped=true&"
import script from "./TipsContainer.vue?vue&type=script&lang=ts&"
export * from "./TipsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053eeae9",
  null
  
)

export default component.exports